<template>
	<div style="padding: 20px 20px 20px 0;" v-loading="loading">
		<div>
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="商铺" name="商铺">
				</el-tab-pane>
	
				<el-tab-pane label="公寓" name="公寓">
				</el-tab-pane>
			</el-tabs>
			<el-form :inline="true" :model="selectForm" ref="selectForm">
				<el-form-item :label="activeName=='商铺'?'商铺编号':'房间号'" prop="shopNum">
					<!-- <el-select filterable v-model="selectForm.shopNum" size="small">
								<el-option v-for="s in list2" :label="s" :value="s"></el-option>
							</el-select> -->
					<el-input size="small" v-model="selectForm.shopNum" :placeholder="activeName=='商铺'?'商铺编号':'房间号'" clearable></el-input>
				</el-form-item>
				<el-form-item label="用电年月">
					<el-date-picker size="small" type="month" value-format="yyyy-MM" placeholder="用电年月" v-model="selectForm.startTime" style="width: 100%;"></el-date-picker>
				</el-form-item>
				<el-form-item label="楼栋" prop="building">
						<el-input size="small" v-model="selectForm.building" placeholder="楼栋" clearable></el-input>
					</el-form-item>
					<el-form-item label="楼层" prop="floor ">
						<el-input size="small" v-model="selectForm.floor" placeholder="楼层" clearable></el-input>
					</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getAll" size="small">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" @click="query();">重置</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" @click="dc()">导出</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" @click="goAdd">新增</el-button>
				</el-form-item>
	
			</el-form>
      <div>{{ sum }}</div>
		</div>
		<el-table :data="data" style="width: 100%">
			<el-table-column prop="shopNum" :label="activeName=='商铺'?'商铺编号':'房间号'" align="center"></el-table-column>
			<el-table-column prop="remark" label="缴费户名" align="center"></el-table-column>
	
			<el-table-column prop="electricityCode" label="电表编码" align="center"></el-table-column>
			<el-table-column prop="lastPositiveElec" label="上月抄数" align="center"></el-table-column>
			<el-table-column prop="positiveElec" label="本月抄数" align="center"></el-table-column>
			<el-table-column prop="difference" label="用电量(kW·h)"  align="center">
      </el-table-column>
			<el-table-column label="环比" align="center">
        <template slot-scope="{ row }">
          <div>
              <span :class="{ 'red': qoq(row) > 30 }">
                {{ qoq(row) }}%
                <i v-if="qoq(row) < 0" class="el-icon-bottom"></i>
                <i v-else class="el-icon-top" ></i>
              </span>
          </div>
        </template>
      </el-table-column>
			<el-table-column label="同比" align="center">
        <template slot-scope="{ row }">
          <div>
            <span :class="{ 'red': yoy(row) > 30 }">
                {{ yoy(row) }}%
                <i v-if="yoy(row) < 0" class="el-icon-bottom"></i>
                <i v-else class="el-icon-top" :class="{ 'red': yoy(row) > 30 }"></i>
              </span>
          </div>
        </template>
      </el-table-column>
			<el-table-column prop="readingTime" label="更新时间" align="center"></el-table-column>
      <el-table-column prop="suggest" label="备注" align="center"></el-table-column>

	
			<!-- <el-table-column label="用电年月" align="center">
						<template slot-scope="{row}">
							{{ row.year }}年{{ row.month }}月
</template>
				</el-table-column> -->
			<!-- <el-table-column prop="positiveElec" label="当前用量(kW·h)" align="center"></el-table-column> -->
			<!-- <el-table-column prop="shouldMoney" label="缴费金额(元)" align="center"></el-table-column>
				<el-table-column prop="property" label="缴费模式" align="center"></el-table-column>
				<el-table-column prop="status" label="结清状态" align="center"></el-table-column> -->
			<!-- <el-table-column label="操作" align="center">
<template slot-scope="scope">
	<el-button type="text" @click="xgRow(scope.row)">
		修改</el-button>
</template>
				</el-table-column> -->
		</el-table>
		<!-- 搜索条件 -->


		<!-- 分页 -->
		<el-pagination v-if="totalNum > 0" @size-change="sizeChange" @current-change="currentChange"
			:page-sizes="[10, 20, 30, 40]" :page-size="selectForm.rows" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum" style="margin-top: 10px;">
		</el-pagination>

		<el-dialog title="电表录入" :visible.sync="show" width="40%">
			<el-form :model="formInline" class="demo-form-inline" ref="formInline" :rules="rules">
				<el-row>
					<el-col  :span="11">
						<el-form-item prop="shopNum" :label="activeName=='商铺'?'商铺编号':'房间号'" label-width="80px">
							<el-input v-model="formInline.shopNum" :placeholder="activeName=='商铺'?'商铺编号':'房间号'"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item prop="remark" label="单位名称" label-width="80px">
							<el-input v-model="formInline.remark" placeholder="单位名称"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item prop="positiveElec" label="累计电量" label-width="80px">
							<el-input v-model="formInline.positiveElec" placeholder="累计电量"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item prop="readingTime" label="抄表时间" label-width="80px">
							<el-date-picker
							style="width:100%;"
							v-model="formInline.readingTime"
							type="datetime"
							placeholder="选择日期时间"
							value-format="yyyy-MM-dd HH:mm:ss" >
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeShow">取 消</el-button>
				<el-button type="primary" @click="ok">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import publicExport from "../../../assets/js/publicExport.js";
export default {
  data() {
    return {
      loading: false,
      queryDate: [],
      sfRoom: null,
      count: null,
      sum: null,
      headerData: {
        Authorization: localStorage.access_token,
      },
      rules: {
        shopNum: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ],
        remark: [
          {
            required: true,
            message: "单位名称不能为空",
            trigger: ["blur", "change"],
          },
        ],
        positiveElec: [
          {
            required: true,
            message: "累计电量不能为空",
            trigger: ["blur", "change"],
          },
        ],
        readingTime: [
          {
            required: true,
            message: "时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      activeName: "商铺",

      oldFormInline: {},
      list: [],
      list2: [],
      form: {
        //表单数据
        name: "",
        age: "",
      },
      oldForm: undefined, //表单备份数据
      data: [], //表格数据
      selectForm: {
        //查询条件
        shopNum: "",
        page: 1, //当前页
        rows: 10, //页大小
        sort: 2,
        startTime: "",
        endTime: "",
        flag: 2,
        building: "",
        floor: "",
      },
      formInline: {
        positiveElec: "",
        readingTime: null,
        remark: null,
        shopNum: null,
        sort: 2,
        flag: 2,
      },
      totalNum: 0, //数据总数
      show: false, //控制弹窗

      title: "",
      disable: false, //节流
    };
  },
  methods: {
    // 环比
    qoq(row) {
     const difference = parseFloat(row.difference)
     const differenceLastMonth = parseFloat(row.differenceLastMonth)
      if (difference && differenceLastMonth) {
        const growth = ((difference - differenceLastMonth) / differenceLastMonth) * 100;
        
        // 保留小数点后2位并四舍五入
        return Math.round(growth * 100) / 100;
      } else {
        return '--';
      }
    },
    yoy(row) {
      const difference = parseFloat(row.difference)
     const differenceLastYear = parseFloat(row.differenceLastYear)
      if (difference && differenceLastYear) {
        const growth = ((difference - differenceLastYear) / differenceLastYear) * 100;
        
        // 保留小数点后2位并四舍五入
        return Math.round(growth * 100) / 100;
      } else {
        return '--';
      }
    },
    closeShow() {
      this.$refs["formInline"].resetFields();
      this.show = false;
    },
    handleClick() {
      this.query();
    },
    dc() {
      publicExport(
        "/api/energy/exportWaterAndElectricity",
        this.selectForm,
        "电表数据"
      );
    },
    // setMonth() {
    // 	let year = new Date().getFullYear()
    // 	let mon = new Date().getMonth() + 1
    // 	mon = mon - 1
    // 	if (mon <= 0) {
    // 		year = year - 1
    // 		mon = mon + 12
    // 	}
    // 	if (mon < 10) {
    // 		mon = '0' + mon
    // 	}
    // 	let queryMonth = year + '-' + mon;
    // 	this.queryDate = [queryMonth, queryMonth]
    // },

    // 上传成功
    handleAvatarSuccess(file) {
      console.log(file);
      this.formInline.filePath = file.data.filePath;
      this.formInline.showPath = file.data.showPath;
      console.log(this.formData);
    },

    xgRow(val) {
      this.show = true;
      this.title = "修改";
      this.formInline = {
        ...val,
      };
    },
    goAdd() {
      this.show = true;
      this.title = "新增";
      this.formInline = JSON.parse(JSON.stringify(this.oldFormInline));
    },
    ok() {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          if (this.selectForm.flag == "1") {
            this.formInline.flag = "1";
          } else {
            this.formInline.flag = "2";
          }
          let url = "/api/energy/insertWaterAndElectricity";
          this.$http
            .post(url, {
              ...this.formInline,
            })
            .then((res) => {
              this.show = false;
              this.$message.success(res.data.message);
              this.getAll();
              console.log(res);
            });
        } else {
          return;
        }
      });

      return;
      // this.disable = true
      // let url = "/api/set"
      // if (this.title[0] == "新") {
      // 	url = "/api/add"
      // }
      // this.$http.post(url, this.form).then(res => {
      // 	this.disable = false
      // 	if (res.data.code == 0) {
      // 		this.show = false;
      // 		this.$message.success(`${this.title}成功`)
      // 		this.getAll();
      // 	} else {
      // 		this.$message.error(`${this.title}失败`)
      // 	}
      // })
    },
    setRow(row) {
      //修改被点击
      // this.form = JSON.parse(JSON.stringify(row))
      // this.title = "修改";
      // this.show = true;
      this.$router.push({
        name: "水电费详情",
        params: {
          val: row,
        },
      });
    },
    close() {
      //弹框关闭
      this.$refs.form.resetFields();
      this.form = JSON.parse(JSON.stringify(this.oldForm));
    },
    getAll() {
      //获取表格数据
      // if (this.queryDate && this.queryDate.length == 2) {
      // 	this.selectForm.startTime = this.queryDate[0]
      // 	this.selectForm.endTime = this.queryDate[1]
      // } else {
      // 	this.selectForm.startTime = ""
      // 	this.selectForm.endTime = ""
      // }
      this.loading = true;
      // if (this.activeName == "商铺") {
      this.$http
        .post(`/api/energy/getWaterAndElectricity`, {
          ...this.selectForm,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.data != null) {
            this.data = res.data.data.items;
            this.totalNum = res.data.data.totalNum;
            this.count = this.totalNum;
            this.sum = res.data.data.sum;
          } else {
            this.data = null;
            this.totalNum = 0;
            this.count = 0;
            this.sum = 0;
          }
        });
      // } else {
      // 	this.loading = false;
      // 	this.data = [];
      // 	this.totalNum = 0;
      // 	this.count = 0;
      // 	this.sum = 0;
      // }
    },
    query() {
      this.selectForm = {
        //查询条件
        shopNum: "",
        page: 1, //当前页
        rows: 10, //页大小
        sort: 2,
        startTime: "",
        endTime: "",
        flag: 2,
        building: "",
        floor: "",
      };
      if (this.activeName == "商铺") {
        this.selectForm.flag = 2;
      } else {
        this.selectForm.flag = 1;
      }
      // this.queryDate = []
      this.getAll();
    },
    sizeChange(size) {
      //页大小被修改
      this.selectForm.rows = size;
      this.getAll();
    },
    currentChange(page) {
      //当前页被修改
      this.selectForm.page = page;
      this.getAll();
    },
  },
  mounted() {
    this.oldFormInline = JSON.parse(JSON.stringify(this.formInline));
    this.getAll();
    // this.setMonth();
  },
};
</script>

<style lang="scss" scoped>
.red {
  color: red;
}
</style>
